import axios from 'axios';
import { req } from './axiosFun';

/**
 * 景点管理
 **/
// 获取景点列表
export const campList = (params) => { return axios.get("/customer/listChaosInfo?page=" + params.currentPage + "&pageSize=" + params.pageSize + "&status=1&pageIndex=" + params.currentPage) };
export const campListSave  = (params) => { return req("post", "/customer/addChaosInfo", params) };
export const campListDel  = (params) => { return req("post", "/customer/deleteChaosInfo", params) };






// WEBPACK FOOTER //
// ./src/api/campsMG10.js